export const CONTRACTS = {
    COLLECTION: {
        queryKey: 'getContracts',
        url: '/contractsAccesses/:contractAccessId'
    },
    USERS: {
        url: '/contractsAccesses/:contractAccessId/users'
    },
    TERMINALS: {
        url: '/contractsAccesses/:contractAccessId/posTerminalsData'
    },
    PERSONALIZATIONS: {
        url: '/contractsAccesses/:contractAccessId/personalizationsData'
    },
    CREATE: {
        url: '/contractsAccesses'
    },
    UPDATE_LABEL: {
        url: '/contractsAccesses/:contractAccessId'
    },
    UPDATE: {
        url: '/contractsAccesses/:contractAccessId/contractProfiles'
    },
    UPDATE_CONTRACT: {
        url: '/contractsAccesses/:contractAccessId/contracts/:contractId'
    },
    ACTIVATE: {
        url: '/contractsAccesses/:uuid/activate'
    },
    DEACTIVATE: {
        url: '/contractsAccesses/:uuid/deactivate'
    },
    ADD_USERS: {
        url: '/contractsAccesses/:uuid/users'
    },
    EXPORT_CONTRACTS: {
        url: '/contractsAccesses/:uuid/contracts/export'
    },
    EXPORT_CONTRACTS_ACCESSES: {
        url: '/contractsAccesses/export'
    },
    ADD_API_KEY: {
        url: '/externalApiKeyData'
    },
    ADD_VAD_CONTRACT: {
        url: '/contractsAccesses/:contractAccessId/externalContractProfile'
    },
    FILE_ACTION: {
        url: '/contractsAccesses/:contractAccessUuid/contractProfiles/fileAction'
    },
    DELETE_MULTIPLE_CONTRACTS: {
        url: '/contractsAccesses/:contractAccessId/contracts'
    }
};

export const SEARCH_CONTRACTS = {
    COLLECTION: {
        url: '/merchantContractsFromProvider'
    },
    DIRECT_PROVIDER_COLLECTION: {
        queryKey: 'getContractsFromProvider',
        url: '/merchantContractsFromDirectProvider'
    },
    EXPORT: {
        url: '/merchantContractsFromProvider/export'
    }
};

export const TERMINAL_CONTRACTS = {
    COLLECTION: {
        queryKey: 'getTerminalContracts',
        url: '/merchantContracts'
    },
    DETAILS: {
        url: '/merchantContracts/:merchantContractId'
    }
};